import { HudIcon } from '../../../../Icons/HudIcons';
import Button from '../../Button/Button';
import { Container } from './MoreOpportunities.styles';

type MoreOpportunitiesProps = {
  caption?: string;
  url?: string;
}

export default function MoreOpportunities({caption, url}: MoreOpportunitiesProps) {
  return (
    <Container>
      <div>
        <HudIcon icon="designSystem.warningTriangleSolid" size="32px" />
        <Button href={url}>{caption}</Button>
      </div>
    </Container>
  );
}
